import { ConfigurationService } from '@mobi/rwc-utils-ng-jslib';
import {
    TealiumConfig,
    TealiumConfigLoader,
    TealiumConfigStaticLoader,
} from '@mobi/tea-tagmanager-ng-jslib';

export function tealiumConfigLoaderFactory(
    configurationService: ConfigurationService,
): TealiumConfigLoader {
    const stage = configurationService.getSync('stage');
    const environment: TealiumConfig['environment'] = stage === 'prod' ? 'prod' : 'dev';

    return new TealiumConfigStaticLoader({
        account: 'mobiliar',
        profile: 'osm',
        environment: environment,
        initialVolatileData: {},
    });
}
